import ky from "ky";
import {
  clearAuthSession,
  isAuthSessionExpired,
  loadAuthSession,
} from "./auth-session";

const baseUrl = process.env.BUN_PUBLIC_API_BASE_URL;

const commonConfig = {
  retry: 0,
  timeout: 120_000,
  hooks: {
    beforeRequest: [
      (request: Request) => {
        const session = loadAuthSession();
        if (!session) return;

        if (isAuthSessionExpired(session)) {
          clearAuthSession();
          return;
        }

        request.headers.set("Authorization", `Bearer ${session.accessToken}`);
      },
    ],
  },
};

export const apiClient = ky.create({
  prefixUrl: baseUrl || undefined,
  ...commonConfig,
});

export const rawHttpClient = ky.create(commonConfig);
